import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  cashflowPriceAuditControl,
  cashflowCheckoutDiscrepancyAuditControl,
} from '../access-control/cashflowAdminAccess.configuration'

const CashflowPriceAuditLandingPage = lazy(
  () => import('../pages/price-audit-landing/CashflowPriceAuditLandingPage')
)
const CashflowPriceAuditDetailsPage = lazy(
  () => import('../pages/price-audit-details/CashflowPriceAuditDetailsPage')
)

const CashflowPriceAuditFeedbackPage = lazy(
  () => import('../pages/price-audit-feedback/CashflowPriceAuditFeedbackPage')
)
const CashflowCheckoutDiscrepancyLandingPage = lazy(
  () => import('../pages/checkout-discrepancy/CheckoutDiscrepancyLandingPage')
)
const CashflowCheckoutDiscrepancyDetailsPage = lazy(
  () => import('../pages/checkout-discrepancy/CheckoutDiscrepancyDetailsPage')
)
const TransactionIntegrityAuditPage = lazy(
  () => import('../pages/transaction-integrity/TransactionIntegrityAuditPage')
)
const TransactionIntegrityReducedAuditPage = lazy(
  () => import('../pages/transaction-integrity/TransactionIntegrityReducedAuditPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const cashflowAdminRouter = (
  <DomainRoute route="app-admin-cashflow">
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-landing"
        component={CashflowPriceAuditLandingPage}
        accessControl={cashflowPriceAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-feedback"
        component={CashflowPriceAuditFeedbackPage}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-details"
        component={CashflowPriceAuditDetailsPage}
        accessControl={cashflowPriceAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-checkout-discrepancy-audit-landing"
        component={CashflowCheckoutDiscrepancyLandingPage}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-checkout-discrepancy-audit-details"
        component={CashflowCheckoutDiscrepancyDetailsPage}
        accessControl={cashflowCheckoutDiscrepancyAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-transaction-integrity-audit"
        component={TransactionIntegrityAuditPage}
        accessControl={cashflowCheckoutDiscrepancyAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-transaction-integrity-reduced-audit"
        component={TransactionIntegrityReducedAuditPage}
        accessControl={cashflowCheckoutDiscrepancyAuditControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
